import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class RoleService {
  roleList: roleModel[] = [
    {
      processName: "Client", permission: "3 General Permissions", content: "Client", id: 1,selected:true,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Client 2", permission: "3 General Permissions", content: "Client 2", id: 2,selected:true,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },

    {
      processName: "Data", permission: "3 General Permissions", content: "Data", id: 3,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Entity", permission: "3 General Permissions", content: "Entity", id: 4,selected:true,
      generalPermission: [
        { permissionName: "Customer Approval" },
        { permissionName: "Vender Approval" },
        { permissionName: "Credit Approval" },
      ]
    },

    {
      processName: "Finance Transaction", permission: "3 General Permissions", content: "Finance Transaction", id: 5,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Bank Book", permission: "3 General Permissions", content: "Bank Book", id: 6,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Bank Receipt", permission: "3 General Permissions", content: "Bank Receipt", id: 7,selected:true,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Process Name 1", permission: "3 General Permissions", content: "Process Name 1", id: 8,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Process Name 2", permission: "3 General Permissions", content: "Process Name 2", id: 9,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
    {
      processName: "Process Name 3", permission: "3 General Permissions", content: "Process Name 3", id: 10,selected:false,
      generalPermission: [
        { permissionName: "Data Verification" },
        { permissionName: "Finance Verification" },
        { permissionName: "Final Approval" },
      ]
    },
  ];
  //roleList$: BehaviorSubject<roleModel[]> = new BehaviorSubject(this._selectedExpense);
}

export interface roleModel {
  processName: string;
  permission: string,
  content: string;
  id: number;
  selected:boolean;
  generalPermission?: generalPermissionModel[];
}
export interface generalPermissionModel {
  permissionName: string;
}